import manageJss from "@microsoft/fast-jss-manager-react";
import { LightweightButtonStyles, } from "@microsoft/fast-components-styles-msft";
import { ButtonBase, } from "../button-base";
import lightweightButtonSchema from "./lightweight-button.schema";
import { DisplayNamePrefix } from "../utilities";
/*
 * The type returned by manageJss type is very complicated so we'll let the
 * compiler infer the type instead of re-declaring just for the package export
 */
/* tslint:disable-next-line:typedef */
const LightweightButton = manageJss(LightweightButtonStyles)(ButtonBase);
/**
 * Set the display name for the lightweight button
 */
LightweightButton.displayName = `${DisplayNamePrefix}LightweightButton`;
export { LightweightButton, lightweightButtonSchema, };
